import { getParametersFromLocalStorage } from "../helpers/commonHelper";

const settings = getParametersFromLocalStorage("settings");

export const paymentTimerConstantValue =
  settings?.find(
    (setting) =>
      setting.parameterName?.toLowerCase() ===
      "paymentPageTimerInSeconds".toLowerCase()
  )?.parameterValue ?? 60;
export const keyencodingTimerConstantValue =
  settings?.find(
    (setting) =>
      setting.parameterName?.toLowerCase() ===
      "KeyEncodingPageTimerInSeconds".toLowerCase()
  )?.parameterValue ?? 60;
export const timerConstantValue =
  settings?.find(
    (setting) =>
      setting.parameterName?.toLowerCase() ===
      "CommonPageTimerInSeconds".toLowerCase()
  )?.parameterValue ?? 60;
export const thankyouPageTimerValue =
  settings?.find(
    (setting) =>
      setting.parameterName?.toLowerCase() ===
      "ThankYouPageTimerInSeconds".toLowerCase()
  )?.parameterValue ?? 20;
export const enablePageTimerEnhancements = !(
  settings
    ?.find(
      (setting) =>
        setting.parameterName?.toLowerCase() ===
        "EnablePageTimerEnhancements".toLowerCase()
    ) //timer reset and freezing
    ?.parameterValue?.toLowerCase() === "false"
);
